<script>
export default {
  name: 'TableDfe',
  props: {
    titles: Array,
    fields: Array,
    generalData: Array,
    totais: Object
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    getClassStatus (status) {
      let oReturn = 's-green'
      switch (status) {
        case 100: oReturn = 's-green'
                  break;
        case 150: oReturn = 's-green-weak'
                  break;
        case   3: oReturn = 's-purple'
                  break;
        case 101: oReturn = 's-purple'
                  break;
        case 102: oReturn = 's-blue'
                  break;
        case 301: oReturn = 's-orange'
                  break;
        case 302: oReturn = 's-orange'
                  break;
      }

      return 'svg-default tf-12 ' + oReturn
    }
  }
}
</script>

<template>
  <div class="main">
    <div class="card-body bg-white p-3 mb-2 overflow-auto">
      <table class="table table-striped" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <th
              v-for="title in titles"
              v-bind:key="title.id"
              :class="title != '' ? 'show-obj' : ''">
                {{title}}
            <th/>
          </thead>
          <tbody>
          <tr v-for="myData in generalData" v-bind:key="myData.id">
              <td style="width: 80px; padding-top: 2px;">
                <label class="container">
                  <input
                    type="checkbox"
                    v-model="myData.checked"  
                  >
                  <span class="checkmark"></span>
                </label>
                <svg :class="getClassStatus(myData['status'])">
                  <circle cx="10" cy="10" r="10" stroke-width="3"/>
                </svg>
              </td>
              <td v-for="row in fields" v-bind:key="row.id">                  
                  {{myData[row.toLowerCase()]}}
              </td>
          </tr>
          </tbody>
      </table>
      <div class="notFound" v-if="generalData.length == 0">
        <p>Nenhum registro encontrado!</p>
      </div>
    </div>
    <div class="card-body bg-white mb-2 p-3">
      <div class="form-row">
        <div class="i-legenda col">
          <svg class="s-green svg-default tf-5">
            <circle cx="10" cy="10" r="10" stroke-width="3"/>
          </svg>
          <a>Autorizada ({{totais.autorizada}})</a>
        </div>
        <div class="i-legenda col">
          <svg class="s-green-weak svg-default tf-5">
            <circle cx="10" cy="10" r="10" stroke-width="3"/>
          </svg>
          <a>Autorizada Fora do Prazo ({{totais.autorizadaForaPrazo}})</a>
        </div>
        <div class="i-legenda col">
          <svg class="s-purple svg-default tf-5">
            <circle cx="10" cy="10" r="10" stroke-width="3"/>
          </svg>
          <a>Cancelada ({{totais.cancelada}})</a>
        </div>
      </div>
      <div class="form-row">
        <div class="i-legenda col">
          <svg class="s-blue svg-default tf-5">
            <circle cx="10" cy="10" r="10" stroke-width="3"/>
          </svg>
          <a>Inutilizada ({{totais.inutilizada}})</a>
        </div>
        <div class="i-legenda col">
          <svg class="s-orange svg-default tf-5">
            <circle cx="10" cy="10" r="10" stroke-width="3"/>
          </svg>
          <a>Denegada ({{totais.denegada}})</a>
        </div>
        <div class="i-legenda col"> <!-- Para alinhar as legendas -->
          <svg class="s-orange svg-default tf-5">
          </svg>
          <a></a>
        </div>        
      </div>
    </div>
  </div>
</template>

<style scoped>  
  .img-download-button{width: 25px;}
  .img-download-button:hover{transition: .3s; transform: scale(1.2)}
  .hide-obj{display: none}
  .show-obj{display: table-cell}
  .notFound{text-align: center; padding: 20px;}
  table {background: white;}
  th {display: none;}

  input[type="checkbox"]{margin-right: 10px;}

  .container {position: relative;  cursor: pointer; font-size: 20px; -webkit-user-select: none; 
    -moz-user-select: none; -ms-user-select: none; user-select: none; width: 10px; }

   /** Checkbox*/
  .container input { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; }
  .checkmark { position: absolute; top: 0; left: 0; height: 20px; width: 20px; background-color: rgb(224, 224, 224); border: solid 1px rgb(209, 209, 209)}
  .container:hover input ~ .checkmark { background-color: #ccc; }
  .container input:checked ~ .checkmark { background-color: #003a66; }
  .checkmark:after { content: ""; position: absolute; display: none; }
  .container input:checked ~ .checkmark:after { display: block; }  
  .container .checkmark:after { left: 7px; top: 3px; width: 5px; height: 10px; border: solid white; border-width: 0 3px 3px 0; -webkit-transform: rotate(45deg); -ms-transform: rotate(45deg); transform: rotate(45deg); }

  /** Circulos-Legenda */
  label{margin-top: 0;}

  .s-green{fill: rgb(95, 185, 59);}
  .s-green-weak{fill: rgb(194, 230, 112);}
  .s-purple{fill: rgb(168, 55, 168);}
  .s-blue{fill: rgb(80, 80, 190);}
  .s-orange{fill: rgb(230, 151, 48);}

  .tf-12 { transform: translateY(12px);}
  .tf-5 { transform: translateY(5px);}
  .svg-default {height: 32px; width: 22px;}
  .i-legenda a{ padding: 10px;}
</style>
